<!-- 任务列表页面 任务进度控制器 -->
<template>
    <div></div>
</template>
 
<script>
import commonUtils from '@/js/workspace/common_util';
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    name: 'taskListProgressControlModule',
    props: {
        taskList: Array,
    },
    data: function () {
        return {
            /**
             * 获取进度任务执行列表
             * {
             *  id: task.id,
             *  type: task.type
             *  branchType: task.branchType
             *  timer: 任务定时器
             *  details: 任务详情
             *  speed: 计算速度 bytes/(nowTime-startTime)
             *  percent: 当前执行进度百分比 runBytes/allBytes*100
             *  errorTimes：0 未获取到进度次数
             * }
             */
            executeList: [],
            isRefresh: false,//是否刷新任务列表
            scheduleNextTime: 9999999999999,//最近定时任务执行时间
            refreshTimer: null,//检测刷新列表定时器
            RUNNING_INTERVAL: 6000,//运行中任务进度获取间隔时间
            REFRESH_INTERVAL: 6000,//检测刷新列表间隔时间
        }
    },
    mounted() {
        //启动刷新定时器
        this.startInterval();
    },
    beforeDestroy() {
        //移除定时器
        if (this.refreshTimer) {
            console.log("移除定时器refreshTimer")
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }
        if (this.executeList.length>0) {
            this.executeList.forEach(item => {
                if(item.timer) {
                    console.log("移除定时器timer")
                    clearInterval(item.timer);
                    delete item.timer;
                }
            });
            
        }
    },
    watch: {
        taskList(newVal, oldVal) {
            if(newVal) {
                console.log("isChange")
                this.detectingTaskStatus();
            }
        },
    },
    methods: {
        /**
         * 检测任务列表中的运行中任务，等待中任务，定时计划任务：
         *  1.运行中任务单独执行获取进度方法
         *  2.等待中任务在符合条件时定时刷新数据
         *  3.定时计划任务获取最近执行时间，每隔3秒检测当前时间是否大于最近执行时间，并刷新数据
         */
        detectingTaskStatus() {
            /**
             * 0：传输任务,邮件传输任务,企业传输任务限制运行1个任务 lowerType: 101 104 106
             * 1：同步任务vip限制运行2个任务，非vip限制运行1个任务 lowerType: 102, branchType: null
             * 2：即时同步任务vip限制运行2个任务，非vip限制运行1个任务 lowerType: 102, branchType: realtime
             * 3：备份任务vip限制任务2个任务，非vip限制运行1个任务 lowerType: 103
             * 4：离线任务vip限制任务5个任务，非vip限制运行1个任务 lowerType: 105
             */
            var runningTasksLimitQuantity = [], waittingTasksQuantity = [[],[],[],[],[]];
            let user = commonUtils.getUser();
            if(user.vip) {
                runningTasksLimitQuantity = [1,2,2,2,5];
            }else {
                runningTasksLimitQuantity = [1,1,1,1,1];
            }
            this.taskList.forEach(task => {
                if(task.status>0) {
                    //非关闭任务
                    var type = this.getTaskType(task);

                    if(task.status==1) {
                        console.log("executeListRun",task)
                        //运行中任务处理

                        //限制数量-1
                        runningTasksLimitQuantity[type]--;

                        //添加执行队列
                        console.log("executeList",this.executeList)
                        let executeTask = this.executeList.find(item=>item.id === task.id);
                        if(!executeTask) {
                            //没有执行中任务时添加进队列
                            this.addExecuteList(task);
                        }

                    }else if(task.status==2) {
                        waittingTasksQuantity[type].push(task);
                    }
                }else {
                    let executeTask = this.executeList.find(item=>item.id === task.id);
                    if(executeTask) {
                        //如果有执行中任务则关闭
                        clearInterval(executeTask.timer);
                        delete executeTask.timer;
                        this.executeList = this.executeList.filter(item => item.id != task.id);
                        this.$store.commit('removeTaskProgress', task.id);
                    }
                }

                if(task.schedules&&!task.schedules.disabled) {
                    //定时任务
                    //设置最近定时任务执行时间
                    this.getTimedExecution(task);
                }
            });

            //计算等待任务是否后获取进度
            console.log("runningTasksLimitQuantity",runningTasksLimitQuantity)
            for (let i = 0; i < runningTasksLimitQuantity.length; i++) {
                const runTaskNum = runningTasksLimitQuantity[i];
                const waitTasks = waittingTasksQuantity[i];
                if(waitTasks.length>0 && runTaskNum>0) {
                    // 等待队列有任务且运行队列有空位时，等待任务也可以获取进度
                    waitTasks.forEach(task => {
                        let executeTask = this.executeList.find(item=>item.id === task.id);
                        if(!executeTask) {
                            //没有执行中任务时添加进队列
                            this.addExecuteList(task);
                        }
                    });
                }
            }

            //计算是否启动等待任务刷新
            // this.computeWaitRefresh(runningTasksLimitQuantity,waittingTasksQuantity);
        },
        //新增executeList子项
        addExecuteList(task) {
            var that = this;
            console.log(task);
            var executeItem = {
                id: task.id,
                type: task.type,
                lowerType: task.lowerType,
                errorTimes: 0,
                workId: task.workId,
                isMultiTask: task.isMultiTask,
            }
            if(task.type == 1 || task.type == 2) {
                console.log(task)
                executeItem.sources = task.sources;
            }

            if(task.type == 2 && task.isMultiTask) {
                console.log("tasksPro",task)
                executeItem.sources = task.sources;
                executeItem.firstId = task.firstId;
                executeItem.firstStatus = task.firstStatus;
            }

            if(task.branchType) {
                executeItem.branchType = task.branchType;
            }

            this.executeList.push(executeItem);

            executeItem.timer = setInterval(async () => {
                //执行获取任务进度
                await that.getProgress(executeItem,function(details){
                    console.log("获取进度结束",details);
                    console.log("获取进度结束",task);
                    if(details) {
                        executeItem.errorTimes = 0;//重置失败次数
                        if(details.runningStatus == 3 && task.type == 2 && task.branchType == 'realtime') {
                            //即时同步任务 如果没有进度，则清除缓存
                            that.$store.commit('removeTaskProgress', task.id);
                        }else if(task.type == 2 && task.isMultiTask) {
                            //如果是多目标同步任务
                            console.log("syncMultiDetails",details);
                            var len = details.length;//总任务数
                            var percent = 0; //进度
                            var proItem = []; //进度信息
                            for (let i = 0; i < len; i++) {
                                const item = details[i];
                                if(item.status == 'Running' || item.status == 'Waiting') {
                                    if(item.progress) {
                                        proItem.push(item.progress);
                                        percent += that.getPercent(task.type,proItem);
                                    }
                                }else if(item.status == 'Done'){
                                    percent += 100/len;
                                }   
                            }
                            let progress = {
                                id: task.id,
                                details: proItem,
                                type: task.type,
                                branchType: task.branchType,
                                lowerType: task.lowerType,
                                percent: Math.floor(percent),
                            }
                            if(proItem) {
                                let isCouting = that.showCountingStatus(task.type,proItem,task.isMultiTask);
                                if(isCouting) {
                                    progress.speed = that.getCountingNum(task.type,proItem,task.isMultiTask);
                                    console.log("count",progress.speed);
                                }else {
                                    progress.speed = that.getSpeed(proItem);
                                    console.log("speed",progress.speed);
                                }
                                that.$store.commit('setTaskProgress', progress);
                                console.log("syncMultiProgress",progress);
                            }
                        }else if(task.lowerType == 105) {
                            //离线任务只有进度
                            let progress = {
                                id: task.id,
                                details: details,
                                type: task.type,
                                branchType: task.branchType,
                                lowerType: task.lowerType,
                                percent: details,
                            }
                            that.$store.commit('setTaskProgress', progress);
                            console.log("progress",progress);
                        }else {
                            let progress = {
                                id: task.id,
                                details: details,
                                type: task.type,
                                branchType: task.branchType,
                                lowerType: task.lowerType,
                                percent: that.getPercent(task.type,details),
                            }
                            let isCouting = that.showCountingStatus(task.type,details,task.isMultiTask);
                            if(isCouting) {
                                progress.speed = that.getCountingNum(task.type,details,task.isMultiTask);
                                console.log("count",progress.speed);
                            }else {
                                progress.speed = that.getSpeed(details);
                                console.log("speed",progress.speed);
                            }
                            //特殊处理，传输任务等待状态进度为0的时候，不显示
                            if(!(task.type == 1 && task.status == 2 && progress.percent == 0 && !isCouting)) {
                                that.$store.commit('setTaskProgress', progress);
                                console.log("progress",progress);
                            }
                        }
                    }else {
                        //如果未能获取到进度
                        let mainTask = that.taskList.find(item=>item.id === task.id);
                        if(mainTask&&mainTask.status!=1) {
                            //非运行任务从队列移除该任务
                            console.log("移除定时器3")
                            clearInterval(executeItem.timer);
                            delete executeItem.timer;
                            that.executeList = that.executeList.filter(item => item.id != task.id);
                            that.$store.commit('removeTaskProgress', task.id);
                        }else if(executeItem.errorTimes<5) {
                            //异常次数+1
                            executeItem.errorTimes++;
                        }else {
                            //从队列移除该任务
                            console.log("移除定时器4")
                            clearInterval(executeItem.timer);
                            delete executeItem.timer;
                            that.executeList = that.executeList.filter(item => item.id != task.id);
                            that.$store.commit('removeTaskProgress', task.id);
                        }
                    }
                });
            },this.RUNNING_INTERVAL);
        },
        //启动刷新定时器
        startInterval() {
            if (this.refreshTimer === null) {
                this.refreshTimer = setInterval(async () => {
                    await this.runRefreshTimer();
                }, this.REFRESH_INTERVAL); // 每3秒执行一次
            }
        },
        //异步刷新列表
        async runRefreshTimer() {
            //判断是否刷新
            if(this.isRefresh || new Date().getTime() > this.scheduleNextTime) {
                this.isRefresh = false;
                await this.$emit("refresh-all");
            }
        },
        //异步获取进度
        async getProgress(task,callback) {
            //区分类型获取进度
            var type = this.getTaskType(task);
            console.log("获取进度开始",new Date());
            console.log(type);
            switch (type) {
                case 1:
                    //同步任务
                    this.getSyncProgress(task,callback);
                    break;
                case 2:
                    //即时同步任务
                    this.getRealtimeSyncProgress(task,callback);
                    break;
                case 3:
                    //备份任务
                    this.getBackupProgress(task,callback);
                    break;
                case 4:
                    //离线任务
                    if(task.type == 5) {
                        //离线种子任务
                        this.getTorrentProgress(task,callback);
                    }else {
                        this.getOfflinesProgress(task,callback);
                    }
                    break;
                default:
                    //默认传输任务
                    this.getTransferProgress(task,callback);
                    break;
            }
        },
        //获取传输任务进度
        getTransferProgress(task,callback) {
            var progressData;
            let user = commonUtils.getUser();
            console.log("getTransferProgress")
            console.log(task)
            if (task.isMultiTask) {
                progressData = new taskListUtils.progressData(user.id, task.type, task.id, null);
            }else {
                progressData = new taskListUtils.progressData(user.id, task.type, task.id, task.workId);
            }
            this.Utils.doTasksRequest("get_progress", progressData, {
                timeout: 60000
            }).then(res => {
                console.log(res);
                if (res.status == 200 && res.progress) {
                    task.errorTimes = 0;//重置失败次数
                    if(task.isMultiTask) {
                        var resItem;
                        if(task.workId == res.progress.state2.taskId) {
                            //多源任务需要当前进度是源任务之一
                            resItem = res.progress;
                        }else{
                            //多源任务需要当前进度是源任务之一
                            $.each(task.sources, function(i, souItem) {
                                if (souItem.workId == res.progress.state2.taskId) {
                                    resItem = res.progress;
                                }
                            });
                        }
                        callback(resItem);
                    }else if(task.workId == res.progress.state2.taskId) {
                        //单源任务是当前任务
                        callback(res.progress);
                    }else {
                        callback(null);
                    }
                }else if (res.status == 200 && res.task){
                    task.errorTimes = 0;//重置失败次数
                    this.isRefresh = true;// 刷新列表
                    callback(null);
                }
            });
        },
        //获取同步任务的进度,
        getSyncProgress(task, callback) {
            var that = this;
            var progressData;
            if (task.isMultiTask) {
                //多目标同步
                
                var tasksPro = [];//整合同步任务各子任务状态和进度信息

                var progressDatas = [];
                var taskProFirst = {
                    id: task.firstId,
                    status: task.firstStatus
                };
                if(task.firstStatus == 'Running' || task.firstStatus == 'Waiting') {
                    progressDatas.push(new taskListUtils.progressData(commonUtils.getUser().id, task.type, task.firstId, null));
                }
                tasksPro.push(taskProFirst);

                //遍历子任务获取进度
                $.each(task.sources, function(index, sourceItem) {
                    var taskPro = {
                        id: sourceItem.id,
                        status: sourceItem.status
                    };
                    if (sourceItem.status == 'Running' || sourceItem.status == 'Waiting') {
                        progressDatas.push(new taskListUtils.progressData(commonUtils.getUser().id, task.type, sourceItem.id, null));
                    }
                    tasksPro.push(taskPro);
                });

                console.log("syncDatas",progressDatas)
                if(progressDatas.length>0) {
                    Promise.all(progressDatas.map(data => this.Utils.doTasksRequest("get_progress",data,{
                        timeout: 60000
                    }))).then((results) => {
                        console.log("syncDatas",results);
                        let isRunning;//判断当前是否有任务在执行
                        for (let i = 0; i < results.length; i++) {
                            const res = results[i];
                            const id = progressDatas[i].id;
                            if (res.status == 200 && res.progress) {
                                if(res.progress.response && (res.progress.response == 'success' || (res.progress.errorList.length && res.progress.errorList[0].cause))) {
                                    //结束任务
                                    let oldTaskIndex = task.sources.findIndex(item => item.id == id);
                                    if(oldTaskIndex>-1) {
                                        task.sources[oldTaskIndex].status = 'Done';
                                    }
                                }else {
                                    let taskPro = tasksPro.find(item => item.id == id);
                                    taskPro.progress = res.progress;
                                    isRunning = true;
                                }
                            }else if(res.status == 200 && res.task) {
                                //重置任务状态
                                if(id == task.firstId) {
                                    task.firstStatus = res.task.status;
                                }else {
                                    let oldTaskIndex = task.sources.findIndex(item => item.id == id);
                                    if(oldTaskIndex>-1) {
                                        task.sources[oldTaskIndex] = res.task;
                                    }
                                }
                            }
                        }
                        console.log("syncDatas",tasksPro);
                        if(isRunning) {
                            callback(tasksPro);
                        }else {
                            task.errorTimes = 0;//重置失败次数
                            this.isRefresh = true;// 刷新列表
                            callback(null);
                        }
                    }), err => {
                        callback(null);
                    };
                }else {
                    task.errorTimes = 0;//重置失败次数
                    this.isRefresh = true;// 刷新列表
                    callback(null);
                }
            }else {
                //单目标同步
                progressData = new taskListUtils.progressData(commonUtils.getUser().id, task.type, task.id, null);
                this.Utils.doTasksRequest("get_progress", progressData, {
                    timeout: 60000
                }).then(res => {
                    if (res.status == 200 && res.progress) {
                        task.errorTimes = 0;//重置失败次数
                        callback(res.progress);
                    }else if (res.status == 200 && res.task) { //如果进度返回200并返回res.task，
                        task.errorTimes = 0;//重置失败次数
                        this.isRefresh = true;// 刷新列表
                        callback(null);
                    }
                });
            }
        },
        getRealtimeSyncProgress(task,callback) {
            let that = this;
            //如果即时同步的任务状态是Init那么循环获取
            let progressData = new taskListUtils.getTasks(commonUtils.getUser().id, task.type, task.id, null);
            this.Utils.doTasksRequest("get_progress", progressData).then(result => {
                console.log(result)
                if (result.status == 200) {
                    if (result.progress) {
                        // 有进度信息
                        if (result.progress.runningStatus <= 1) {
                            // 当前仍然在执行中，继续获取进度
                            callback(result.progress);
                        } else {
                            // 返回运行中，等待下次执行
                            callback(result.progress);
                        }
                    } else {
                        // 无进度信息，需要判断仍然是运行中
                        callback({runningStatus:3});
                    }
                }
            });
        },
        getBackupProgress(task, callback) {
            var transferInfo;
            var progressData;
            if (task.sources) {
                progressData = new taskListUtils.progressData(commonUtils.getUser().id, task.type, task.id, null);
            }else {
                progressData = new taskListUtils.progressData(commonUtils.getUser().id, task.type, task.id, task.workId);
            }
            this.Utils.doTasksRequest("get_progress", progressData, {
                timeout: 60000
            }).then(res => {
                //如果返回进度数据
                if (res.status == 200) {
                    if(res.progress) {
                        console.log("getBackupProgress",task.id == res.progress.id)
                        if (task.id == res.progress.id) { //如果返回的是该任务的进度，或者是有详情的多源任务
                            //对任务详情进行赋值
                            transferInfo = res.progress;
                            //stateSet排序
                            if (transferInfo.stateSet) {
                                let firstSet = [];
                                $.each(transferInfo.stateSet, function(toIndex, setItem) {
                                    if (setItem.status == 0) {
                                        firstSet.unshift(setItem);
                                    } else {
                                        firstSet.push(setItem);
                                    }
                                });
                                transferInfo.stateSet = firstSet;
                            }
                            // this.calculationBackupSpeed(task, transferInfo);
                        }
                        // if (transferInfo && transferInfo.totalFileCount) {
                        //     task.totalFileCount = transferInfo.totalFileCount;
                        // }
                        task.errorTimes = 0;//重置失败次数
                        callback(transferInfo);
                    }else if(res.task){
                        task.errorTimes = 0;//重置失败次数
                        this.isRefresh = true;// 刷新列表
                        callback(null);
                    }
                }else {
                    this.isRefresh = true;// 刷新列表
                    callback(null);
                }
            });
        },
        getOfflinesProgress(task,callback) {
            var that = this;
            let getData = {
                ud: commonUtils.getUser().id,
                id: task.id,
                type: task.type,
            }
            this.Utils.doTasksRequest('get_progress', getData).then(res => {
                if (res.status == 200) {
                    console.log("getTorrentProgress",res)
                    if (res.progress != 'TASK_CANCELED') {
                        callback(res.progress);
                    } else {
                        task.errorTimes = 0;//重置失败次数
                        this.isRefresh = true;// 刷新列表
                        callback(null);
                    } 
                } else {
                    this.isRefresh = true;// 刷新列表
                    callback(null);
                }
            });
        },
        getTorrentProgress(task,callback) {
            const requestData = {
                ud: commonUtils.getUser().id,
                id: task.id,
                type: 0,
                totalSize: 0,
                selectedSize: 0,
                fileList: [],
                toItem: {},
            }
            this.Utils.doTorrentRequest('progress', requestData).then(res => {
                if (res.status == 200) {
                    console.log("getTorrentProgress",res)
                    if (res.data) {
                        callback(res.data.progress);
                    } else {
                        task.errorTimes = 0;//重置失败次数
                        this.isRefresh = true;// 刷新列表
                        callback(null);
                    }
                } else {
                    this.isRefresh = true;// 刷新列表
                    callback(null);
                }
            });
        },
        //Utils
        //获取任务的限制类型
        getTaskType(task) {
            /**
             * 0：传输任务,邮件传输任务,企业传输任务 lowerType: 101 104 106
             * 1：同步任务 lowerType: 102, branchType: null
             * 2：即时同步任务 lowerType: 102, branchType: realtime
             * 3：备份任务 lowerType: 103
             * 4：离线任务 lowerType: 105
             */
            let type;
            if(task.lowerType==101||task.lowerType==104||task.lowerType==106) {
                //传输任务共用限制
                type = 0;
            }else if(task.lowerType==102) {
                //同步任务
                if(task.branchType=="realtime") {
                    //即时同步
                    type = 2;
                }else {
                    type = 1;
                }
            }else if(task.lowerType==103) {
                //备份任务
                type = 3;
            }else if(task.lowerType==105) {
                //离线任务
                type = 4;
            }
            return type;
        },
        //计算是否启动等待任务刷新
        computeWaitRefresh(runList,waitList) {
            for (let i = 0; i < runList.length; i++) {
                //有执行队列空位并且有等待任务时（即对应位置均为true），允许刷新
                if(runList[i]&&waitList[i].length){
                    console.log("有等待任务");
                    this.isRefresh = true;
                    return;
                }
            }
        },
        //定时获取任务进度
        getTimedExecution(item) {
            console.log("getTimedExecution");
            var nextTime;
            let that = this;
            let nowTime = new Date().getTime(); //获取现在时间的时分秒
            if (item.schedules) {
                let timeSchedule = item.schedules;
                //获取类型为一次还未过时的任务
                if (timeSchedule.type == 'Once' && !timeSchedule.outDate) {
                    //若该任务今天就执行，计算即将执行时间
                    var onceTime = that.calculDateTimeNext(timeSchedule);
                    if(onceTime > nowTime){
                        nextTime = onceTime;
                    }
                }
                //获取类型为每日运行的任务
                if (timeSchedule.type == 'Daily') {
                    let timeArr = that.getDailyNext(timeSchedule);
                    for (let k = 0; k < timeArr.length; k++) { //计算时间差，开始执行
                        if (nowTime < timeArr[k]) {
                            nextTime = timeArr[k];
                        }
                    }
                }
                //获取类型为每周运行的任务
                if (timeSchedule.type == 'Weekly') {
                    let weeKTime = that.getWeeklyNext(timeSchedule);
                    if (weeKTime && weeKTime > nowTime) { //若有即将执行的任务开始执行
                        nextTime = weeKTime;
                    }
                }
                //获取类型为每月运行的任务
                if (timeSchedule.type == 'Monthly') {
                    let monthTime = that.getMonthlyNext(timeSchedule);
                    if (monthTime && monthTime > nowTime) { //若有即将执行的任务开始执行
                        nextTime = monthTime;
                    }
                }
            }
            if(this.scheduleNextTime > nowTime){
                //如果定时大于当前时间，则判断需要打开定时功能
                if(nextTime && this.scheduleNextTime > nextTime) {
                    //如果有更新的定时时间，则使用更新的
                    this.scheduleNextTime = nextTime;
                }
            }else {
                this.scheduleNextTime = 9999999999999;
            }
            console.log('scheduleNextTime',this.scheduleNextTime);
        },
        //获取即将执行的Daily定时任务时间集合
        getDailyNext(timeSchedule) {
            let valueTimes;
            let timeArr = [];
            var that = this;
            valueTimes = timeSchedule.times;
            for (let i = 0; i < valueTimes.length; i++) {
                if (valueTimes[i]) {
                    timeArr.push(that.calcuTimeNext(valueTimes[i]));
                }
            }
            timeArr = timeArr.slice().sort(function(a, b) {
                return a - b
            });
            return timeArr;
        },
        //获取即将执行的weekly定时任务时间差
        getWeeklyNext(timeSchedule) {
            let that = this;
            let weekArr;
            let nextWeek;
            let nextTime;
            let nowWeek = new Date().getDay() + 1;
            weekArr = timeSchedule.weeks;
            if (weekArr) {
                weekArr = weekArr.slice().sort(function(a, b) {
                    return a - b
                });
                for (let i = 0; i < weekArr.length; i++) {
                    if (nowWeek <= weekArr[i] && weekArr[i] != 0) {
                        nextWeek = parseInt(weekArr[i]);
                        break;
                    } else {
                        nextWeek = 0;
                    }
                }
            }
            //如果每周执行的时间为今天
            if (nextWeek == nowWeek) {
                nextTime = this.calcuTimeNext(timeSchedule.times[0]);
            }
            return nextTime;
        },
        //获取即将执行的monthly定时任务时间差
        getMonthlyNext(timeSchedule) {
            let nextTime;
            let nextDay;
            let dayArr;
            let monthDayArr = new Array;
            let nowDate = new Date().getDate();
            dayArr = timeSchedule.days;
            if (dayArr && dayArr.length) {
                $.each(dayArr, function(i, itemData) {
                    if (itemData && typeof(itemData) == 'string') {
                        let itemSpace = itemData.trim();
                        itemSpace = parseInt(itemSpace);
                        monthDayArr.push(itemSpace);
                    }
                });
                if (monthDayArr.length) {
                    dayArr = monthDayArr;
                } else {
                    dayArr = dayArr;
                }
                dayArr = dayArr.slice().sort(function(a, b) {
                    return a - b
                });
                for (let i = 0; i < dayArr.length; i++) {
                    if (nowDate <= dayArr[i]) {
                        nextDay = dayArr[i];
                        break;
                    } else {
                        nextDay = dayArr[0];
                    }
                }
            }
            if (nowDate == nextDay) {
                nextTime = this.calcuTimeNext(timeSchedule.times[0]);
            }
            return nextTime;
        },
        //计算将执行时间
        calculDateTimeNext(schedule) {
            let onceTime = schedule.date + " " + schedule.times[0];
            //标准日期格式转成Long型
            var nextTimeLong = new Date(onceTime.replace(new RegExp("-", "gm"), "/")).getTime();
            return nextTimeLong;
        },
        //计算执行时间为今天的时间
        calcuTimeNext(time) {
            let now = new Date(); //获取今天的日期
            var arr = time.split(":");
            let hours = parseInt(arr[0]); //时转为秒
            let minutes = parseInt(arr[1]); //分转为秒
            let seconds;
            if (arr[2]) {
                seconds = parseInt(arr[2]);
            } else {
                seconds = 0;
            }
            now.setHours(hours);
            now.setMinutes(minutes);
            now.setSeconds(seconds);
            now.setMilliseconds(0); // 将毫秒设为0
            
            // 获取时间
            return now.getTime();//返回今天即将执行的时间
        },
        //获取速率
        getSpeed(details) {
            let date;
            if(details.state2) {
                date = details.state2;
            }else {
                date = details;
            }
            let startTime = date.taskStartTimeLong;
            let endTime = new Date().getTime();
            let bytes = 0;
            if(date.readedBytes) {
                bytes = date.readedBytes;
            }else {
                //云备份
                bytes = date.totalReadedBytes;
            }
            let speed = 0;
            if(startTime && bytes && endTime>startTime) {
                speed = Math.round(bytes/((endTime - startTime)/1000));
            }
            return this.Utils.formatByteSpeed(speed);
        },
        //获取进度
        getPercent(type,details) {
            let percent = 0;
            switch (type) {
                case 1:
                    //传输任务
                    let date;
                    if(details.state2) {
                        date = details.state2;
                    }else {
                        date = details;
                    }
                    if (date.nextCount) { //如果返回了nextCount，任务进度以fileCountPercent为准
                        if (date.totalFileCount == 1 && date.totalBytes > 0) {
                            percent = Math.floor((date.readedBytes / date.totalBytes) * 100);
                        } else {
                            percent = Math.floor((date.nextCount / date.totalFileCount) * 100);
                        }
                    }else {
                        percent = Math.floor(commonUtils.calculationPercent(date.state2));
                    }
                    break;
                case 2:
                    //同步任务
                    if (details.totalFileCount && !isNaN(details.response)) {
                        percent = Math.floor((parseInt(details.response) / details.totalFileCount) * 100);
                    } else {
                        percent = 0;
                    }
                    if (details.totalFileCount <= 2 && details.totalBytes>0) {
                        percent = Math.floor(((details.readyBytes / details.totalBytes) * 100));
                    }
                    break;
                case 6:
                    //备份任务
                    if(details.nextCount) {
                        percent = Math.floor(((details.nextCount / details.totalFileCount) * 100));
                    }else {
                        percent = 0;
                    }
                    break;
                default:
                    break;
            }
            return percent;
        },
        //获取文件处理进度文本
        getCountingNum(type,details,isMultiTask) {
            var countNum = 0;
            if (type == 1) {
                countNum = details.state2.readyFindFileCount;
            }else if (type == 2) {
                if (!isMultiTask) {
                    countNum = details.readyFindFileCount;
                }else {
                    var allreadyFindFileCount;
                    $.each(details, function(sIndex, sItem) {
                        //如果任务状态在运行或者等待中
                        if ((sItem.status == 'Running' || sItem.status == 'Waiting' || (sItem.runningStatus == 0))) {
                            allreadyFindFileCount += sItem.readyFindFileCount;
                        }
                    });
                    countNum = allreadyFindFileCount;
                }
            }else if (type == 6) {
                countNum = details.readyFindFileCount;
            }
            return this.$t('language.common.countingFilesTip',{num:countNum});
        },
        //判断是否显示文件处理进度
        showCountingStatus(type,details,isMultiTask) {
            console.log(details);
            if (type == 1) {
                if (details && details.state2 && details.state2.status == 1) {
                    return true;
                }
            } else {
                if(type == 2 && isMultiTask) {
                    var flag;
                    $.each(details, function(sIndex, sItem) {
                        //如果任务状态在运行或者等待中
                        if ((sItem.status == 'Running' || sItem.status == 'Waiting' || (sItem.syncDetail && sItem.syncDetail.runningStatus == 0))) {
                            flag = true;
                        }
                    });
                    return flag;
                }else {
                    if ((details && details.runningStatus == 1) || (details.runningStatus <= 1 && details.type == 2 && details.branchType == 'realtime')) {
                        return true;
                    }
                }
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/controller/task_list_progress_control.vue